// copy from src/pages/dashboard/components/MetricsCardWrap/index.tsx
// with additional overlapClassName prop

import React from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';
import BasicImage from '@home/components/BasicImage';
import IconTips from '@sg/components/IconTips';
import DefinitionBubble from '@sg/components/DefinitionBubble';
import info from '@sg/assests/svg/info.svg';
import "./index.scss";
import classnames from 'classnames';
import { getImg } from '@home/_config/getImgs';
import CommonBubble from '@home/components/CommonBubble';
import FormatHtmlTextToReact from '@home/components/FormatHtmlTextToReact';

interface MetricsCardWrapTitleProps {
  icon?: string;
  titleIcon?: string;
  imgUrl?: string; // 图片地址
  tips?: React.ReactNode;
  definition?: string;
  source?: string;
  updateTime?: string;
  isJumpable?: boolean;
  // 是否开启icon的info提示（与标题hover的提示互斥）
  isIconTips?: boolean;
  title?: React.ReactNode;
  className?: string;
  overlayClassName?: string;
  hasTitleLink?: boolean;
  onClick?: () => void;
}

const MetricsCardWrapTitle: React.FC<MetricsCardWrapTitleProps> = (props) => {
  const {
    icon,
    titleIcon,
    imgUrl,
    tips,
    definition,
    source,
    updateTime,
    isJumpable,
    isIconTips,
    title,
    className,
    overlayClassName,
    onClick,
  } = props;
  const hasDefinitionInfo = !!(definition || source || updateTime);

  return (
    <CommonBubble
      placement="top"
      content={typeof tips === 'string' && tips && !isIconTips ? <FormatHtmlTextToReact text={tips} /> : null}
    >
      <div className='dbd-metrics-card-wrap__title' onClick={onClick}>
        {icon && (
          <div className="dbd-metrics-card-wrap__title__icon">
            <SvgIcon type={icon} className="text-icon" />
          </div>
        )}
        {titleIcon && (
          <img className='dbd-metrics-card-wrap__title__img__icon' src={getImg(titleIcon)} />
        )}
        {imgUrl && <BasicImage src={imgUrl} className={classnames('dbd-metrics-card-wrap__title__img', className)} />}
        <div className='dbd-metrics-card-wrap__title__text' title={String(title)}>
          {title}
        </div>
        {isJumpable && <SvgIcon className='dbd-metrics-card-wrap__title__right-icon' type='arrow-right' />}
        {isIconTips && (
          hasDefinitionInfo ? (
            <DefinitionBubble
              definition={definition}
              source={source}
              updateTime={updateTime}
              style={{ maxWidth: '450px' }}
            >
              <div className="dbs-icon-tips-icon dbd-metrics-card-wrap__title__tips-info">
                <div className="dbs-icon-tips-wrapper" style={{ width: '16px', height: '16px' }}>
                  <img
                    src={info}
                    alt="info"
                    className="dbs-icon-tips-icon-svg"
                    style={{ width: '16px', height: '16px' }}
                  />
                </div>
              </div>
            </DefinitionBubble>
          ) : (
            <IconTips
              tipString={tips}
              className='dbd-metrics-card-wrap__title__tips-info'
              overlayClassName={overlayClassName}
            />
          )
        )}
      </div>
    </CommonBubble>
  );
};

export default MetricsCardWrapTitle;
